import { render, staticRenderFns } from "./TitleC.vue?vue&type=template&id=1f83107e&scoped=true"
import script from "./TitleC.vue?vue&type=script&lang=js"
export * from "./TitleC.vue?vue&type=script&lang=js"
import style0 from "./TitleC.vue?vue&type=style&index=0&id=1f83107e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83107e",
  null
  
)

export default component.exports